module.exports = __webpack_public_path__ + "img/bglogo.8084c200.svg";